import { scrollParent } from 'components/utils/scroll';

const UNIT_REM = 10;

export function getDropdownOptionsSettings({
  element,
  options,
  extraContentHeight = 0,
  optionsHeight = 5,
  maxOptionsHeight = 20,
  borderHeight = 0.2,
  defaultOptionsPosition = 'bottom',
}) {
  let position = defaultOptionsPosition;

  const optionsTotalHeight =
    (options.length * optionsHeight + borderHeight + extraContentHeight) *
    UNIT_REM;
  const maxHeight =
    (maxOptionsHeight + borderHeight + extraContentHeight) * UNIT_REM;

  const optionsDivHeight =
    optionsTotalHeight > maxHeight ? maxHeight : optionsTotalHeight;

  const isOptionsOverflowBottom =
    element.getBoundingClientRect().bottom + optionsDivHeight >
    document.defaultView.innerHeight;
  const isOptionsOverflowTop =
    element.getBoundingClientRect().top - optionsDivHeight < 0;

  if (!isOptionsOverflowTop && isOptionsOverflowBottom) {
    position = 'top';
  }

  if (isOptionsOverflowTop && !isOptionsOverflowBottom) {
    position = 'bottom';
  }

  return {
    height: optionsDivHeight / UNIT_REM,
    position,
  };
}

export function getOverflowDropdownOptionsSettings({
  element,
  options,
  extraContentHeight = 0,
  optionsHeight = 5,
  borderHeight = 0.2,
  defaultOptionsPosition = 'bottom',
}) {
  let position = defaultOptionsPosition;
  const scrollEl = scrollParent(element);
  const elementDimensions = element.getBoundingClientRect();
  const scrollDimensions = scrollEl.getBoundingClientRect();

  const optionsTotalHeight =
    (options.length * optionsHeight + borderHeight + extraContentHeight) *
    UNIT_REM;

  const isOptionsOverflowTop =
    elementDimensions.top - optionsTotalHeight <
    scrollDimensions.top - scrollEl.scrollTop;

  const isOptionsOverflowBottom =
    elementDimensions.bottom + optionsTotalHeight >
    scrollDimensions.bottom +
      scrollEl.scrollHeight -
      scrollEl.offsetHeight -
      scrollEl.scrollTop;

  if (!isOptionsOverflowTop && isOptionsOverflowBottom) {
    position = 'top';
  }

  if (isOptionsOverflowTop && !isOptionsOverflowBottom) {
    position = 'bottom';
  }

  return {
    position,
  };
}

export function getFixedDropdownOptionsSettings({
  element,
  options,
  optionsPosition = 'bottom',
  optionsHeight = 5,
  extraContentHeight = 0,
  borderHeight = 0.2,
  marginVertical = 1,
}) {
  const optionsTotalHeight =
    (options.length * optionsHeight + borderHeight + extraContentHeight) *
    UNIT_REM;

  const isOptionsOverflowBottom =
    element.getBoundingClientRect().bottom + optionsTotalHeight >
    document.defaultView.innerHeight;

  const isOptionsOverflowTop =
    element.getBoundingClientRect().top - optionsTotalHeight < 0;

  if (!isOptionsOverflowTop && !isOptionsOverflowBottom) {
    return { position: optionsPosition };
  }

  if (!isOptionsOverflowTop && isOptionsOverflowBottom) {
    return { position: 'top' };
  }

  if (isOptionsOverflowTop && !isOptionsOverflowBottom) {
    return { position: 'bottom' };
  }

  return {
    position: 'center',
    style: {
      [optionsPosition]: `${marginVertical}rem`,
    },
  };
}
